module.exports = __webpack_public_path__ + "img/Z85-X18-中_15.db559a36.jpg";